    angular.module('lead-bant', ['core'])
        .factory('LeadBantQuestions', function ($resource) {
            return  $resource('/crm/api/lead-bant-questions/:id', {id: "@id"}, {
                table: {method: 'GET', isArray: false, url: '/crm/api/lead-bant-questions/table'},
                get: {method: 'GET'},
                update: {method: 'PUT'},
                answers: {method: 'GET', isArray: false, url: '/crm/api/lead/:id/bant'},
                saveAnswers: {method: 'POST', url: '/crm/api/lead/:id/bant'},
                updateAnswers: {method: 'PUT', url: '/crm/api/lead/:id/bant'},
                deleteAnswers: {method: 'DELETE', url: '/crm/api/lead/:id/bant'}
            });
        })
        .service('LeadBantService', function ($rootScope, modals, LeadBantQuestions) {
            this.add = () => {
                return modals.open('app/lead/bant/edit-modal.html', 'LeadBantQuestionsEditController', {}, {size: "md"}, "$ctrl")
            }
            this.edit = (id) => {
                return modals.open('app/lead/bant/edit-modal.html', 'LeadBantQuestionsEditController', {id: id}, {size: "md"}, "$ctrl")
            }
            this.delete = item => {
                return modals.confirmDelete(item.id, () => LeadBantQuestions.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('lead-bant.deleted')))
            }
        })
        .controller('LeadBantQuestionsEditController', function ($scope, $rootScope, $uibModalInstance, LeadBantQuestions, data) {
            this.$onInit = () => {
                if (data.id != null)
                    LeadBantQuestions.get({id: data.id}).$promise.then(item => this.item = item)
                else
                    this.item = {}
            }
            this.save = () => {
                let promise
                if (this.item.id != null) {
                    promise = LeadBantQuestions.update(this.item).$promise
                } else {
                    promise = LeadBantQuestions.save(this.item).$promise
                }
                return promise.then(() => {
                    $uibModalInstance.close()
                    $rootScope.$broadcast('lead-bant.updated')
                })
            }

            this.cancel = () => $uibModalInstance.dismiss('cancel')
        })
        .component('leadBantQuestionsList', {
            bindings: {
                filters: '<',
                page: '<'
            },
            templateUrl: 'app/lead/bant/list.html',
            controller: function ($scope, $state, $stateParams, LeadBantService, LeadService) {
                this.LeadBantService = LeadBantService;
                this.LeadService = LeadService;

                this.reset = () => this.filters = {};

                $scope.$on('lead-bant.updated', () => $state.reload());
                $scope.$on('lead-bant.deleted', () => $state.reload());
            }
        })
        .config(function ($stateProvider) {
            $stateProvider.state('leadBantQuestionsList', {
                parent: 'app',
                url: '/lead-bant-questions?{page:int}',
                data: {
                    authorities: ['ROLE_LEADS']
                },
                views: {
                    'content@': 'leadBantQuestionsList'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (LeadBantQuestions, $stateParams) => LeadBantQuestions.table(angular.copy($stateParams)).$promise
                }
            });
        });
